module.exports = __webpack_public_path__ + "static/media/ins-4.868bd469.jpg";